import { IHeading } from "./types";

export const brading: IHeading = {
  title: "Trusted by Industry Leaders",
  content:
    "CDI has developed relationships with industry leaders in the Managed Services Provider space.The MSP’s have standardized on CDI for secure out of band management.",
};

export const listLeader = [
  "i_TMobile",
  "i_att",
  "i_bt",
  "i_lumen",
  "i_hp",
  "i_ibm",
  "i_verizon",
];

export const enviroments = [
  {
    title: "Recyclable packaging",
    detail:
      "All our packaging is cardboard and 100 percent recyclable. We separate all waste to reduce landfill contents and have a large containers for all packaging material to be placed outside.",
  },
  {
    title: "Energy-efficient facilities",
    detail:
      "We have converted all of our office space, warehouse space and Parking lot lights to high efficiency LED fixtures.",
  },
  {
    title: "High Efficiency Power Supplies for Products",
    detail:
      "We are working with a third party to have solar energy on our property. This will generate electricity for our needs and the surplus will be sent back to the grid. Our power supplies are all high efficiency switching supplies.",
  },
];
